<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, getCurrentInstance } from 'vue';
import { useState, useMutations, useActions } from '@/composables/useVuexHelpers';
import DocumentTeam from '@/views/public/DocumentTeam.vue';
import { xhr } from '@/xhr/endpoints';
import { EventBus } from '@/assets/js/event-bus';

const instance = getCurrentInstance();
const $route = instance?.proxy?.$route;

const { idToken, currentTeam } = useState(['idToken', 'currentTeam']);

const team = computed(() => currentTeam.value);

const { setCurrentTeam, setTeams, setCurrentDocumentID } = useMutations([
  'setCurrentTeam',
  'setTeams',
  'setCurrentDocumentID',
]);

const { getDocumentWithCounterpoints } = useActions(['getDocumentWithCounterpoints']);

onMounted(async () => {
  // set empty team
  setCurrentDocumentID($route?.params.documentId as string);
  await getDocumentWithCounterpoints();

  const res = await xhr.getTeamDetails($route?.params.teamId as string, idToken.value);
  setCurrentTeam(res);
  setTeams(res);
});

onBeforeUnmount(() => {
  EventBus.emit('hide.modals.team');
});
</script>

<template>
  <div class="uk-flex uk-flex-column" v-if="team">
    <!--
      Component DocumentTeam is nested here because TeamSettings was originally meant to hold other team settings besides members
      Left as is for future development
    -->
    <DocumentTeam :team="team" :showSubTitle="false" />
  </div>
</template>

<style lang="scss">
.error {
  input {
    border-color: red;
  }
}
</style>
